<template>
  <div v-if="item">
    <div class="columns is-marginless is-paddingless">
      <div class="column">
        <div class="container" style="display: flex">
          <h1 class="title">{{ item.vinNo }}</h1>
          <b-button
            class="is-size-7"
            style="margin: 1px 0 0 5px"
            icon-left="trash-alt"
            v-if="!item.status || item.status == 0"
            @click="deleteOrder"
          />
          <div
            class="container toolbar"
            style="margin: 1px 0px 0px 5px"
            v-if="
              item.transportEstimatedArrivalDate &&
              item.status == 2 &&
              item.matterNo
            "
          >
            <b-button
              @click="itemClick(item)"
              class="is-size-7"
              icon-left="plus"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              {{ totalRequestTransport + 1 }} 回目陸送</b-button
            >
            <!-- <b-button
              icon-left="undo"
              :disabled="this.item.checktransportRevert === false"
              v-if="this.item.status == 2"
              @click="itemClicktran()"
              class="is-size-7"
              style="display: flex; top: -30px; margin-left: 98px"
            >
              陸送キャンセル</b-button
            > -->
          </div>
        </div>
      </div>
      <div
        class="column has-text-right"
        style="margin-top: auto; margin-bottom: auto"
      >
        <div class="container">
          <b-button
            type="is-primary"
            icon-left="arrow-left"
            inverted
            v-if="prevItem"
            @click="goto(prevItem.id)"
            >Prev</b-button
          >
          <b-button
            type="is-primary"
            icon-right="arrow-right"
            inverted
            v-if="nextItem"
            @click="goto(nextItem.id)"
            >Next</b-button
          >
        </div>
      </div>
    </div>
    <div class="columns is-marginless is-paddingless">
      <div class="column is-5">
        <div class="container">
          <section class="section is-marginless is-paddingless mb-5">
            <ItemImageGallery :images="item.images()" />
          </section>
        </div>
      </div>
      <div class="column is-7">
        <div class="container">
          <section class="section is-marginless is-paddingless mb-5">
            <h2 class="title is-size-5">車両情報</h2>
            <ItemAuction
              :item="item"
              :auctions="auctions"
              :isBookedItem="isBookedItem"
              :trantest="trantest"
              @calc="calc"
              @responeValidateItemAuction="responeValidateItemAuction"
              @auctionVendorChanged="auctionVendorChanged"
            />
            <section class="section is-marginless is-paddingless mb-5">
              <ItemPos :item="item" :isBookedItem="isBookedItem" />
            </section>
            <section class="section is-marginless is-paddingless mb-5">
              <ItemVehicle
                :item="item"
                :previosVinNo="previosVinNo"
                :isTransport="isTransport"
                :isBookedItem="isBookedItem"
                @responeValidateItemVehical="responeValidateItemVehical"
                @responeUpdateSuccess="responeUpdateSuccess"
              />
            </section>
            <section class="section is-marginless is-paddingless mb-5">
              <ItemCondition :item="item" :isBookedItem="isBookedItem" :transportVendors="transportVendors"/>
            </section>
          </section>
        </div>
      </div>
    </div>
    <div class="columns is-marginless is-paddingless">
      <div class="column is-5">
        <div class="container">
          <section class="section is-marginless is-paddingless mb-5">
            <section class="section is-marginless is-paddingless mb-5">
              <ItemCustomer
                :item="item"
                ref="validateCustomer"
                :listCustomerInf="listCustomerInf"
                :checkEditPrice="checkEditPrice"
                @responeValidateItemCustomer="responeValidateItemCustomer"
              />
            </section>
            <h2 class="title is-size-5">輸出代行</h2>
            <ItemAAS :item="item" :yards="yards" :checkEditPrice="checkEditPrice" @calc="calc" />
          </section>
        </div>
      </div>
      <div class="column is-7">
        <div class="container">
          {{ item.a }}
          <section class="section is-marginless is-paddingless mb-5">
            <h2 class="title is-size-5">陸送手配</h2>
            <ItemTransport :key="item.id"
                           :item="item"
                           :yards="yards"
                           :handlingCompanys = "handlingCompanys"
                           :transportCosts="transportCosts"
                           :transportVendors="transportVendors"
                           :selectedAuctionVendor="selectedAuctionVendor"
                           :isFetching="isFetching"
                           :isBookedItem="isBookedItem"
                           :tranReverts="tranReverts"
                           ref="validateTransport"
                           :isOrder="isOrder"
                           @calc="calc"
                           :checkEditPrice = checkEditPrice
                           @responeValidateItemTransport="responeValidateItemTransport" />
          </section>
        </div>
      </div>
    </div>
    <div class="columns is-marginless is-paddingless">
      <div class="column"></div>
      <div
        class="column has-text-right"
        style="margin-top: auto; margin-bottom: auto"
      >
        <div class="container">
          <b-button
            type="is-primary"
            icon-left="arrow-left"
            inverted
            v-if="prevItem"
            @click="goto(prevItem.id)"
            >Prev</b-button
          >
          <b-button
            type="is-primary"
            icon-right="arrow-right"
            inverted
            v-if="nextItem"
            @click="goto(nextItem.id)"
            >Next</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import itemRepository from '@/repositories/item';
import jcPackage from '@/repositories/jcPackage';
import _debounce from 'lodash/debounce';
import moment from 'moment';
import constants from '../utils/constants';
import Firebase from '../infra/firebase';
const regexEmppty = /^$/;
export default {
  components: {
    ItemImageGallery: () => import('@/components/ItemImageGallery.vue'),
    ItemVehicle: () => import('@/components/ItemVehicle.vue'),
    ItemAuction: () => import('@/components/ItemAuction.vue'),
    ItemPos: () => import('@/components/ItemPost.vue'),
    ItemAAS: () => import('@/components/ItemAAS.vue'),
    ItemCondition: () => import('@/components/ItemCondition.vue'),
    ItemTransport: () => import('@/components/ItemTransport.vue'),
    ItemCustomer: () => import('@/components/ItemCustomer.vue'),
  },
  watch: {
    item: {
      deep: true,
      handler: function (val, oldVal) {
        if (val.transportFromName == '') {
          val.transportFromName = this.originalTransportFromName;
        }
        if (val.transportToName == '') {
          val.transportToName = this.originalTransportToName;
        }
        if (oldVal && val.id == oldVal.id) {
          this.debouncedSave(val);
        }
      },
    },
    $route: function () {
      this.init();
    },
  },
  data: () => ({
    item: null,
    originalTransportFromName: '',
    originalTransportToName: '',
    toggleDetailItems: false,
    transportCosts: [],
    isFetching: false,
    selectedAuctionVendor: null,
    orderItems: [],
    totalRequestTransport: 0,
    previosVinNo: '',
    isValidItemVehical: false,
    isValidItemAuction: false,
    isValidItemTransport: false,
    isValidItemCustomer: false,
    isTransport: false,
    previousNumberPlate: false,
    listCustomerInf: [],
    isBookedItem: false,
    isOrder: false,
    auction_date: '',
    auction_number: '',
    auction_place_id: '',
    transportRequestCount: 0,
    isAllBooked: false,
    tranReverts: null,
    trantest: null,
    checkEditPrice: false,
    statusOld : 0,
    unsubscribeSnapshot: null
  }),
  async created() {
    this.$store.commit('isLoadingApi', true);
    this.init();
    await this.getData();
    await this.getNewItem();
    this.$store.commit('isLoadingApi', false);
  },
  computed: {
    nextItem() {
      return this.$store.getters.nextItemInList(this.item);
    },
    prevItem() {
      return this.$store.getters.prevItemInList(this.item);
    },
  },
  mounted() {
    this.setUpRealTimeListener(this.$route.params.id);
  },
  methods: {
    setUpRealTimeListener(docId) {
      if(!docId) return;
      const db = Firebase.instance.db;
      const docRef = db.collection("Orders").doc(docId);

      this.unsubscribeSnapshot = docRef.onSnapshot( { includeMetadataChanges: true }, (docSnap) => {
        if (docSnap.exists) {
          let order = docSnap.data();
          this.checkEditPrice = order.isInvoiceFinish === '1' ? true : false
          if(order.isInvoiceFinish === '1') this.isBookedItem = true
         }
      });
    },
    stopListening() {
      if (this.unsubscribeSnapshot) {
        this.unsubscribeSnapshot();
        this.unsubscribeSnapshot = null;
      }
    },
    auctionVendorChanged(vendor) {
      this.selectedAuctionVendor = vendor;
      this.item.yardTransportId = vendor ? vendor.AA_ID.value : '';
      this.item.yardTransportName = vendor
        ? vendor.AuctionAreaSatellite.value
        : '';
      this.item.yardAdressTransport = vendor ? vendor.Address.value : '';
      this.item.yardAreaTransport = vendor ? vendor.Big_Area.value : '';
      this.item.placeId = vendor ? vendor.PlaceId.value: null;
      this.item.satelliteId = vendor ? vendor.PlaceSatelliteId.value : null;
    },
    async calc() {
      this.transportCosts = [];
      //yard to yard
      if (this.item.fromYardPlace > 0){
        if (
        !this.item.transportUseYardsForTransportTo ||
        this.item.transportFromId == '' ||
        this.item.transportToArea == '' ||
        this.item.fromYardPlace == null || this.item.fromYardPlace == -1 || this.item.fromYardPlace ==''||
        this.item.customerId == '' || this.item.yardId ==''
        ) {
          return;
        }
        //START QUOCNV 20230529 add new feature get value yard to yard
        let placeYardType = '1';
        if (this.item.yardCategory=='1') {
          placeYardType = '2';
        } 
        //END QUOCNV 20230529 add new feature get value yard to yard
        this.isFetching = true;
        this.transportCosts = await this.$store.dispatch('getTransportCosts', {
          auctionSiteId: this.item.placeId,
          satelliteId: this.item.satelliteId,
          area: this.item.yardId,
          customerId: this.item.customerId,
          category: this.item.yardCategory,
          fromYardPlace: this.item.fromYardPlace,
          placeYardType: placeYardType
        });
      }else{
        //place to yard 

        if (
        !this.item.transportUseYardsForTransportTo ||
        this.item.transportFromId == '' ||
        this.item.transportToArea == '' || 
        this.item.placeId == null || 
        this.item.placeId == '' ||
        this.item.customerId == ''
        ) {
         return;
        }
        this.isFetching = true;

        this.transportCosts = await this.$store.dispatch('getTransportCosts', {
          auctionSiteId: this.item.placeId,
          satelliteId: this.item.satelliteId,
          area: this.item.yardId,
          customerId: this.item.customerId,
          category: this.item.yardCategory,
          fromYardPlace: this.item.fromYardPlace,
          placeYardType : '0'
        });
        this.isFetching = false;
      }
      
    },
    async save(item) {
      this.$refs.validateCustomer.validation();

      if (
        this.isValidItemVehical ||
        this.isValidItemAuction ||
        this.isValidItemTransport ||
        this.isValidItemCustomer
      ) {
        return;
      }
      if (
        this.item.transportRequestConfirmDate != '' &&
        regexEmppty.test(this.item.transportCost)
      ) {
        this.alertError(
          '陸送費（実費）もしくは陸送費（請求）に金額が設定されておりません。金額を入力してください。０円も可。'
        );
        return;
      }
      if (this.item.hasNumberPlate != this.previousNumberPlate) {
        this.item.hasNumberPlateChange = true;
      }

      //START QuocNV 20240119 check Customer - VinNo display alert
      if(this.item.vinNo != 'new order') {
        let listData = await itemRepository.getListItemByVinNo(this.item.vinNo);
        let checkVinNo =  listData.filter(res => res.id != this.item.id && res.vinNo == this.item.vinNo && 
                                          (res.matterNo =='' || res.matterNo != this.item.matterNo))
        let messageCheckVinNo = "";
        if(checkVinNo.length > 0) {
          messageCheckVinNo = "違う顧客番号で同一車体番号が存在するため、車体番号がnew orderに上書きされました";
        }
        let checkCusVinno = listData.filter(res => res.id != this.item.id && res.vinNo == this.item.vinNo 
                                            && res.customerId == this.item.customerId && (this.item.matterNo =='' || res.matterNo != this.item.matterNo))
        if(checkCusVinno.length > 0) {
          messageCheckVinNo = "同一顧客・同一車両が存在します";
        }

        if(messageCheckVinNo) {
          this.alertError(
            messageCheckVinNo
          );
          item.vinNo = 'new order';
          item.checkDupplicateVinNo = false;
          await this.$store.dispatch('saveItem', item);
          await this.$store.dispatch('fetchOrdersAndBookingItems');
          this.$store.commit('setOrdersCount', this.$store.getters.incompleteItems.length);
          return;
        }
        item.checkDupplicateVinNo = true;
      }
      
      //END QuocNV 20240119 check Customer - VinNo display alert
      
      if (
        this.item.conditionChecked &&
        this.item.transportToName != '' &&
        item.transportVendorId != ''
      ) {
        if (this.item.transportRequestConfirmDate == '') {
          if (this.item.status == 0) {
            this.item.yardConfirmationDate = String(
              new Date().toLocaleDateString('en-ZA')
            );
            this.item.yardConfirmed = this.$store.state.user.displayName;
          }
        }
        if (this.item.transportRequestConfirmDate != '') {
          if (this.item.status == 0) {
            this.item.yardConfirmationDate = String(
              new Date().toLocaleDateString('en-ZA')
            );
            this.item.yardConfirmed = this.$store.state.user.displayName;
            this.item.landTransportationArrangementDate = String(
              new Date().toLocaleDateString('en-ZA')
            );
            this.item.landTransportationArranger = this.$store.state.user.displayName;
          }
          if (this.item.status == 1) {
            this.item.landTransportationArrangementDate = String(
              new Date().toLocaleDateString('en-ZA')
            );
            this.item.landTransportationArranger = this.$store.state.user.displayName;
          }
        }
       
        if (this.auction_date == '') {
          jcPackage
            .getAuctionOderByMatterNo(
              this.$store.state.accessTokenJPC,
              this.item.matterNo
            )
            .then((rs) => {
              if (rs.data) {
                this.auction_date = rs.data.auction_date;
                this.auction_number = rs.data.auction_number;
                this.auction_place_id = rs.data.auction_place_id;
              }
            });
        }
        //20220426 Task188 start
        if (
          this.item.status == 2 &&
          this.item.matterNo != ''
        ) {
          // update new crm
          // if (this.transportRequestCount == 0 && this.item.transportRequestConfirmDate != '') {
          //   const dataTransport = {
          //     matter_no: this.item.matterNo,
          //     delivery_plan: this.item.transportRequestConfirmDate,
          //   };
          //   jcPackage
          //     .getTransportRequest(
          //       this.$store.state.accessTokenJPC,
          //       dataTransport
          //     )
          //     .then((rs) => {
          //       if (rs.data) {
          //         this.transportRequestCount = rs.data;
          //       }
          //     });
          // }
          
          //START QuocNV 20241219 add task 246 rikuso
          if(this.statusOld != 2 && this.item.status == 2){
            this.statusOld = 2;
            this.totalRequestTransport ++;
          }
          //END QuocNV 20241219 add task 246 rikuso
          
          const auctionId = constants.ID_MAPPING.find(
            (v) => v.id == this.auction_place_id
          );
          if (auctionId) {
            this.auction_place_id = auctionId.value;
          }
          const yardCityCRM = this.yards.find(
            (v) => v.AREA_NAME.value == this.item.transportToId
          );

          if (this.item.transportRequestConfirmDate != ''){
            const dataRequestCRM = {
            authentication: {
              username: 'newcrm001',
              password: 'P@S832v932Kvhy',
            },
            record: {
              auction_date: this.auction_date.replaceAll('/', '-'),
              auction_number: this.auction_number,
              auction_place_id: this.auction_place_id,
              order_date: this.item.transportRequestConfirmDate,
              port: yardCityCRM ? yardCityCRM.Yard_City_Name.value : '',
              handling_company: yardCityCRM ? yardCityCRM.handling_company_en.value : 'Japan Carrier',
              delivery_yard: yardCityCRM ? yardCityCRM.AREA_NAME.value : '',
              transpoter: 'Japan Carrier', //yardCityCRM ? yardCityCRM.handling_company_en.value : 'Japan Carrier'
              yard_in_date: this.item.transportEstimatedArrivalDate
                ? this.item.transportEstimatedArrivalDate
                : '',
              cost: this.item.transportTotalCost,
              land_transportation_times: this.totalRequestTransport,
              chassis_no: this.item.vinNo,
            },
            };
            jcPackage
            .requestUpdateCRM(dataRequestCRM, this.$store.state.accessTokenJPC)
            .then((rs) => {
              //nothing
            })
            .catch((err) => {
              console.log(err);
            });
          } else if (this.item.transportRequestConfirmDate == ''){
            const dataRequestCRM = {
            authentication: {
              username: 'newcrm001',
              password: 'P@S832v932Kvhy',
            },
            record: {
              auction_date: this.auction_date.replaceAll('/', '-'),
              auction_number: this.auction_number,
              auction_place_id: this.auction_place_id,
              order_date: '',
              port: '',
              handling_company: '',
              delivery_yard:'',
              transpoter: '', //yardCityCRM ? yardCityCRM.handling_company_en.value : 'Japan Carrier'
              yard_in_date: '',
              cost: '',
              land_transportation_times: this.totalRequestTransport,
              chassis_no: this.item.vinNo,
            },
            };
            jcPackage
            .requestUpdateCRM(dataRequestCRM, this.$store.state.accessTokenJPC)
            .then((rs) => {
              //nothing
            })
            .catch((err) => {
              console.log(err);
            });
          }
          
        }
        //20220426 Task188 end

        //START QuocNV 08112023 delete transport
        if( this.item.transportRequestConfirmDate == '' && this.item.status == 2){
          if(this.item.transportFromName != ''  && this.item.transportToName !='' && this.item.matterNo != '' && this.item.orderDate){
            const params = {
              location_from: this.item.transportFromName,
              location_to: this.item.transportToId != '' ? this.item.transportToId :  this.item.transportToName,
              order_date: this.item.orderDate,
              matter_no: this.item.matterNo,
              firebase_id: this.item.id
            }
            jcPackage.deleteTransport(this.$store.state.accessTokenJPC,params)
            .then((rs) => {
              console.log(rs);
              // this.item.transportDetailId = 0;
            })
            .catch((err) => {
              console.log(err);
            });
          }
        //END QuocNV 08112023 delete transport
        //START QuocNV 20112023 update fee rikuso to jcpack
        } 
        // else if (this.item.transportRequestConfirmDate != '' && this.item.status == 2 ){
        //   if (this.item.transportActualCost !='' && this.item.transportCost != '' && this.item.matterNo !='' &&
        //       this.item.orderDate != '' && this.item.transportFromName !='' && this.item.transportToName !='' ) {
        //       const params = {
        //         location_from: this.item.transportFromName,
        //         location_to: this.item.transportToId != '' ? this.item.transportToId :  this.item.transportToName,
        //         order_date: this.item.orderDate,
        //         matter_no: this.item.matterNo,
        //         customer_price : this.item.transportCost,
        //         transport_price : this.item.transportActualCost
        //       }
        //       jcPackage.updateTransportFeeRikuso(this.$store.state.accessTokenJPC,params)
        //       .then((rs) => {
        //         console.log(rs);
        //       })
        //       .catch((err) => {
        //         console.log(err);
        //       });
        //   }
        // }
        //END QuocNV 20112023 update fee rikuso to jcpack

        //START QuocNV 20240813 get transportDetailId before save
        if (
            this.item.status == 2 && (this.item.transportDetailId  == 0 || this.item.transportDetailId == null) && this.item.transportRequestConfirmDate != ''
          ) {
            // let itemTemp = await itemRepository.getItemById(this.item.id);
            // if (itemTemp) {
            //   item.transportDetailId = itemTemp.transportDetailId;
            //   this.item.transportDetailId = itemTemp.transportDetailId;
            // }
        }
        //END QuocNV 20240813 get transportDetailId before save
      }
      
      await this.$store.dispatch('saveItem', {
        ...item,
        mileage : item.mileage || 0,
        updateTime : (new Date()).getTime()
      });
      await this.$store.dispatch('fetchOrdersAndBookingItems');
      this.$store.commit('setOrdersCount', this.$store.getters.incompleteItems.length);
    },
    async init() {
      this.orderItems = this.$store.getters.incompleteItems;
      this.$store.commit('setOrdersCount', this.orderItems.length);
      this.item = this.$store.getters.findItemById(this.$route.params.id);
      if (!this.item) {
        this.$router.push({ name: 'orders' });
        return;
      }
      //START QuocNV 20241219 add task 246 rikuso
      this.statusOld = this.item.status;
      //END QuocNV 20241219 add task 246 rikuso
      if(!this.item.numberPlatePickUp && this.item.transportRemarks){
        this.item.transportRemarks = this.item.transportRemarks.replace(/ナンバーカット済み/g, '');
      }
      if (this.item.regExpiryDate && this.item.transportOptionNumberPlateCut) {
        this.listCustomerInf = this.$store.state.listCustomerInf;
        if (this.listCustomerInf.length > 0) {
            let findCust = this.listCustomerInf.find(x => x.customer_id_format === this.item.customerId);
            this.item.numberDeliveryAddress = findCust ? findCust.address_3 : '';
            this.item.transportRemarks = 'ナンバー送付先：'+this.item.numberDeliveryAddress;
        }
        } else {
          this.item.transportRemarks = this.item.transportRemarks ? this.item.transportRemarks.replace(/ナンバー送付先：/g, '').replace(this.item.numberDeliveryAddress, '') : '';
          this.item.numberDeliveryAddress = '';
       }
        if (this.item.requestVehicleNumberCut) {
            this.item.transportRemarks = 'ナンバー送付先：ジャパンキャリアー/135-0044　東京都江東区越中島1-2-13-7Ｆ';
             this.item.numberDeliveryAddress = 'ジャパンキャリアー/135-0044　東京都江東区越中島1-2-13-7Ｆ';
        }else{
            this.item.transportRemarks = this.item.transportRemarks.replace(/ナンバー送付先：ジャパンキャリアー\/135-0044　東京都江東区越中島1-2-13-7Ｆ/g, '');
          }

      this.debouncedSave = _debounce(this.save, 1000);
      this.isBookedItem =  this.item.status === 2 ? true : false;
      this.isAllBooked = this.$route.params.isAllBooked;
      this.isOrder = this.$route.params.isOrder;
      
      this.previousNumberPlate = this.item.hasNumberPlate ? this.item.hasNumberPlate : '';
      this.previosVinNo = this.item.vinNo ? this.item.vinNo : '';
      this.originalTransportFromName = this.item.transportFromName ? this.item.transportFromName : '';
      this.originalTransportToName =  this.item.transportToName ? this.item.transportToName : '';
      this.auctions = this.$store.state.auctionVendors;
      this.yards = this.$store.state.yardVendors;
      this.handlingCompanys = this.$store.state.handlingCompany;
      this.transportVendors = this.$store.state.transportVendors;
      this.checkEditPrice = this.item.isInvoiceFinish === '1' ? true : false;
      this.calc();
      if (this.item.matterNo != '') {
        this.$store.commit('isLoadingApi', true);
        //START QuocNV 20241219 add task 246 rikuso
        let filterTemp = [];
        let countRecord = 0;
        filterTemp = await itemRepository.getListUpdateCustomers(this.item.matterNo);
        if (filterTemp.length > 0) {
          countRecord =  filterTemp.filter(res => res.status == "2" ).length;
        }
        this.$store.commit('isLoadingApi', false);
        this.totalRequestTransport = countRecord;
        //END QuocNV 20241219 add task 246 rikuso
        // const totalRequestTransportApi = jcPackage.getTotalTransportByMatterNo(
        //   this.$store.state.accessTokenJPC,
        //   this.item.matterNo
        // );
        // totalRequestTransportApi
        //   .then((rs) => (this.totalRequestTransport = rs.data))
        //   .finally(() => {
        //     this.$store.commit('isLoadingApi', false);
        //   });

        // get inf from transport
        // const dataTransport = {
        //   matter_no: this.item.matterNo,
        //   delivery_plan: this.item.transportRequestConfirmDate,
        // };
        // jcPackage
        //   .getTransportRequest(this.$store.state.accessTokenJPC, dataTransport)
        //   .then((rs) => {
        //     if (rs.data) {
        //       this.transportRequestCount = rs.data;
        //     }
        //   });
      }
      this.listCustomerInf = this.$store.state.listCustomerInf;
      if ( this.item.status === 2 && this.item.transportDetailId > 0) {
        this.checkEditPrice = await jcPackage.checkPaymentPriceRikuso(
          this.$store.state.accessTokenJPC,
          this.item.transportDetailId
        )
      }
    },
    async getNewItem() {
      if ( this.item &&
        this.item.transportRequestConfirmDate != '' &&
        this.item.status == 2 &&
        this.item.matterNo != ''
      ) {
        const data = {
          matterNo: this.item.matterNo,
          orderDate: this.item.orderDate,
        };
        const assets = await Promise.all([
          itemRepository.bookedRevert1(this.item),
          itemRepository.bookedRevert(this.item),
        ]);
        if (!assets[1]) {
          this.item.checktransportRevert = false;
        } else if (assets[0].length < 2) {
          this.item.checktransportRevert = false;
        } else {
          if (assets[0][0].id !== this.item.id) {
            this.item.checktransportRevert = false;
          } else {
            this.item.checktransportRevert = true;
          }
        }
      }
    },
    responeValidateItemVehical(listMessage) {
      if (listMessage.msgVinNo != '' || listMessage.msgYear != '') {
        this.isValidItemVehical = true;
      } else {
        this.isValidItemVehical = false;
      }
    },
    responeValidateItemAuction(listMessage) {
      if (listMessage.msgLotNo != '') {
        this.isValidItemAuction = true;
      } else {
        this.isValidItemAuction = false;
      }
    },
    responeValidateItemTransport(listMessage) {
      if (
        !regexEmppty.test(listMessage.msgCost) ||
        !regexEmppty.test(listMessage.msgTransportCost)
      ) {
        this.isValidItemTransport = true;
      } else {
        this.isValidItemTransport = false;
      }
    },
    responeValidateItemCustomer(listMessage) {
      if (
        listMessage.msgId != '' ||
        listMessage.msgGrade != '' ||
        listMessage.msgTel != ''
      ) {
        this.isValidItemCustomer = true;
      } else {
        this.isValidItemCustomer = false;
      }
    },
    responeUpdateSuccess() {
      this.isValidItemVehical = false;
      this.previosVinNo = this.item.vinNo;
      this.save(this.item);
    },
    goto(id) {
      this.$router.push({ name: 'item', params: { id } });
    },
    deleteOrder() {
      this.$buefy.dialog.confirm({
        message: `${this.item.vinNo} を削除しますか？`,
        onConfirm: async () => {
          await itemRepository.delete(this.item.id);
          await this.$store.dispatch('fetchOrdersAndBookingItems');
          this.$buefy.toast.open('削除しました');
          if (this.nextItem) {
            return this.goto(this.nextItem.id);
          }
          this.$router.push({ name: 'orders' });
        },
      });
    },
    getData() {
      if (this.$store.getters.transportVendorsWithItems.length > 0) {
        this.filterDate(
          this.$store.getters.transportVendorsWithItems[0].items,
          this.orderItems
        );
      }
    },
    filterDate(data, items) {
      let arrayIndex = [];
      let arrayData = [];
      data.map((x) => {
        this.orderItems.map((y, index) => {
          if (
            x.vinNo == y.vinNo &&
            x.transportFromId == y.transportFromId 
          ) {
            arrayIndex.push(index);
          }
        });
      });
      this.orderItems.map((x, index) => {
        let a = arrayIndex.indexOf(index);
        if (a < 0) {
          arrayData.push(x);
        }
      });
      this.orderItems = [...arrayData];
      this.$store.commit('setOrdersCount', this.orderItems.length);
    },
    itemClick(p) {
      // jcPackage
      //   .addOrUpdateTransport(this.$store.state.accessTokenJPC, this.item)
      //   .then((rs) => {
      //     this.$router.push({
      //       name: 'transport',
      //       params: {
      //         id: p.id,
      //       },
      //     });
      //   });
      this.$router.push({
        name: 'transport',
        params: {
          id: p.id,
          totalRequestTransport: this.totalRequestTransport + 1
        },
      });
    },
    alertError(msg) {
      this.$buefy.dialog.alert({
        title: 'Error',
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        icon: 'times-circle',
        iconPack: 'fa',
        ariaRole: 'alertdialog',
        ariaModal: true,
      });
    },
    alertSuccess(msg) {
      this.$buefy.dialog.alert({
        title: 'Request Success',
        type: 'is-success',
        hasIcon: true,
        icon: 'check-circle',
        iconPack: 'fa',
        message: msg,
        confirmText: 'OK!',
        ariaRole: 'alertdialog',
        ariaModal: true,
      });
    },
    itemClicktran() {
      const message = '陸送をキャンセルされました。';
      const msg = '';
      this.tranReverts = true;
      this.trantest = true;
      const now = new Date();
      const data = {
        matterNo: this.item.matterNo,
        orderDate: this.item.orderDate,
      };
      this.$store.dispatch('getItemByMatterNo', data).then((s) => {
        // console.log(s)
        if (s == null) {
          this.alertError(msg);
          return;
        } else {
          const params = {
            matterNo: this.item.matterNo,
            location_from: s.transportToId,
            inland_company: s.transportVendorName,
            delivery_plan: this.item.transportRequestConfirmDate,
            date_in_yard: this.item.transportEstimatedArrivalDate,
          };
          jcPackage
            .requestUpdateTransportRequest(
              this.$store.state.accessTokenJPC,
              params
            )
            .then((rs) => {
              //not thing
            })
            .catch((err) => {
              console.log('updateRevertTransport', err);
            });
          let date = moment(new Date()).format('YYYY-MM-DD');
          this.item.transportToAddress = s.transportToAddress;
          this.item.transportToArea = s.transportToArea;
          this.item.transportToId = s.transportToId;
          this.item.transportToIncharge = s.transportToIncharge;
          this.item.transportToPhone = s.transportToPhone;
          this.item.transportToName = s.transportToName;
          this.item.transportVendorName = s.transportVendorName;
          this.item.transportActualCost = 0;
          this.item.transportCost = 0;
          this.item.transportTotalActualCost = 0;
          this.item.transportTotalCost = 0;
          this.item.transportTotalActualCost = 0;
          this.item.transportRequestConfirmDate = date;
          this.item.transportEstimatedArrivalDate = date;
          this.item.orderDate = date;
          this.item.checktransportRevert = false;
          this.alertSuccess(message);
        }
      });
    },
  },
  beforeDestroy(){
    this.stopListening();
  },
};
</script>
